export const paths = {
  SETUP_PROFILE: 'profile',
  SETUP_NAME: 'name',
}

export const setupLinks = {
  profileSetupLink: () => `/${paths.SETUP_PROFILE}`,
  profileSetupNameLink: () => `/${paths.SETUP_NAME}`,
}

export type SetupLinks = typeof setupLinks
